export const APP_ICONS = [
  '3D_model',
  'act',
  'activity_unassigned',
  'AD_light_disabled',
  'AD_light_enabled',
  'add',
  'add_alarm_criterion',
  'add_alert',
  'add_as_homepage',
  'add_asset',
  'add_column',
  'add_columns',
  'add_dataset',
  'add_enpi',
  'add_folder',
  'add_image',
  'add_link',
  'add_note',
  'add_photo',
  'add_row',
  'add_rows',
  'add_ticket_homepage',
  'add_user',
  'add_workorder_homepage',
  'agenda',
  'ai',
  'alarm',
  'alarm_clock',
  'alarm_full',
  'alarm_off',
  'alarm_on',
  'alarm_on_full',
  'alert',
  'alert_full',
  'align_center',
  'align_left',
  'align_right',
  'ameliorative_action_sidenav',
  'analytics',
  'and',
  'anomaly',
  'apps',
  'archive',
  'area',
  'arrow2_down',
  'arrow2_left',
  'arrow2_right',
  'arrow2_up',
  'arrow3_down',
  'arrow3_left',
  'arrow3_right',
  'arrow3_up',
  'arrow_circle_down',
  'arrow_dots',
  'arrow_down',
  'arrow_down_circle',
  'arrow_go_back',
  'arrow_left',
  'arrow_left_right',
  'arrow_right',
  'arrow_up',
  'arrow_up_circle',
  'artifical-intelligence',
  'artificial-intelligence',
  'asset',
  'asset_icon',
  'asset_management',
  'assistance',
  'associate_site',
  'attach2',
  'attach_rotate',
  'attached',
  'auc_roc_curve',
  'autocorrelation',
  'axes',
  'bad',
  'bag',
  'bar_chart',
  'benchmark',
  'benchmark2',
  'binarizer',
  'box_plot',
  'bracket_left',
  'bracket_right',
  'bubble_chart_icon',
  'bubbles',
  'builder',
  'calendar',
  'calendar_note',
  'card',
  'card_carousel_loading',
  'cart',
  'Categoric_Box_plot',
  'Categoric_histogram',
  'Categories_plot',
  'cefla_logo',
  'change_request',
  'chart_of_percentage_deviations',
  'charts_settings',
  'check',
  'check_circle',
  'checkbox',
  'chevron_right',
  'chiave_inglese',
  'Chiudi',
  'close',
  'close_circle',
  'coded_element',
  'colors',
  'columns',
  'comma',
  'comments',
  'compare_sites',
  'compress',
  'confusion_matrix',
  'Constraint',
  'contractor',
  'copy',
  'create_dataset',
  'create_first_group',
  'create_first_report',
  'create_test_dataset',
  'create_time_frame',
  'crea_dataset',
  'cusum',
  'cusum2',
  'cusum_tabular',
  'dashboard&report',
  'dashboard',
  'Data Experience',
  'data_experience',
  'data_experience2',
  'data_visualization',
  'dataset',
  'dataset_copy',
  'date_range',
  'Deadline_setting',
  'Deviations_chart',
  'device',
  'device_profile_picture',
  'diary',
  'dimensionality_reduction',
  'discretization',
  'divide',
  'Do',
  'document',
  'document2',
  'document3',
  'do_not_disturb',
  'double_arrow',
  'double_arrow_left',
  'double_arrow_right',
  'download',
  'drag_drop',
  'drag_handle',
  'drop',
  'duplicate_activity',
  'duplicate_memo',
  'edit',
  'edit_calendar',
  'edit_homepage',
  'edit_link',
  'edit_schedule',
  'edit_time_period',
  'empty_cell',
  'empty_values',
  'empty_values2',
  'en',
  'encoding',
  'energy',
  'energy_monitoring',
  'entry_box',
  'equal',
  'es',
  'esc_fullscreen',
  'euro',
  'euro2',
  'event',
  'event_sidenav',
  'exclamation',
  'exit_box',
  'expand',
  'exponential_function',
  'export',
  'facilities',
  'favorite',
  'features_selection',
  'file',
  'filter_list',
  'filters',
  'finalized_labor',
  'fingerprint',
  'first_page',
  'fixed_frequency_resampling',
  'flow',
  'flow2',
  'flow3',
  'folder',
  'folder2',
  'Following',
  'frame_bubble',
  'frame_copy',
  'frame_copy2',
  'frequency',
  'full_star',
  'fullscreen',
  'funnel',
  'genealogy',
  'graph',
  'grid',
  'history_measure_empty',
  'home',
  'homepage',
  'homepage_contractors',
  'homepage_ticket',
  'homepage_workorder',
  'homepage_planner',
  'hourglass',
  'hourglass_planner',
  'hyperparameter',
  'idea',
  'image',
  'import',
  'importance_variables',
  'improvement_action',
  'info',
  'infomapping',
  'innest',
  'insert_parameter',
  'integral_function',
  'iot',
  'istogram',
  'istogram2',
  'Istogram_dataset',
  'it',
  'label',
  'label_extension',
  'labelling',
  'last_page',
  'layer',
  'Layout',
  'layout_1',
  'layout_3',
  'layout_4',
  'Layout_6',
  'layout_free',
  'left_panel_close',
  'left_panel_open',
  'license_manager_login',
  'Like2',
  'link',
  'list',
  'little_star',
  'location',
  'lock',
  'logarithm',
  'logo_cmms',
  'logo_documenti',
  'logo_mipu',
  'logo_spareparts',
  'logo_ticket',
  'machinery',
  'mail',
  'maintenance',
  'map',
  'Mappatura_cluster',
  'marker_site',
  'maths',
  'matrix',
  'measure',
  'measure2',
  'measure_profile_picture',
  'measure_ruler',
  'measures_meters',
  'memo',
  'Menu',
  'messages',
  'meter',
  'meter_explanation',
  'meter_profile_picture',
  'mindstore',
  'minus',
  'minus_circle',
  'Model_research',
  'modify_request',
  'multiply',
  'natural_logarithm',
  'negative_evaluation_green',
  'negative_evaluation_red',
  'new_AI_model',
  'no_data',
  'No_data_',
  'no_dataxp',
  'no_documents',
  'no_ticket',
  'Non_ci_sono_Documenti',
  'Non_ci_sono_elementi',
  'not_allowed',
  'not_selected',
  'note',
  'notify',
  'novacoop_logo',
  'novacoop_toolbar',
  'number_format',
  'odl',
  'OdL_marker',
  'one_hot_encoding',
  'or',
  'other',
  'other_vert',
  'output_bar',
  'Output_profile_classification',
  'pareto',
  'pause',
  'pdr',
  'percentage',
  'performance',
  'performance_profile',
  'personalize',
  'Pie_chart',
  'pin',
  'pin_circle',
  'pipeline',
  'pipeline_columns',
  'pipeline_rows',
  'play',
  'play_circle',
  'play_pause',
  'play_sqaure',
  'plus_minus',
  'pod',
  'polynomial_features',
  'positive_evaluation_green',
  'positive_evaluation_red',
  'pow_2',
  'power',
  'prediction_chart',
  'Predictions_comparison_steps',
  'prevision_explain_chart',
  'print',
  'product_icon',
  'publish',
  'qr_code',
  'quantity',
  'rebecca_logo',
  'rebecca_logo_white',
  'redisuals',
  'redo',
  'refresh',
  'remove',
  'remove_selection',
  'report',
  'report2',
  'restore',
  'restore_dataset',
  'Risorsa',
  'rlm_logo',
  'Rolling_statistics',
  'rubber',
  'save',
  'save_pencil',
  'scaling',
  'scatterplot_bubble',
  'scenari_icon',
  'scheduling_register',
  'scope',
  'score_separation',
  'search',
  'server',
  'set_up_frame',
  'settings',
  'share',
  'signature',
  'sistema_icon',
  'site',
  'Site_icon',
  'Site_marker',
  'site_planner',
  'sites',
  'smart_labelling',
  'smartphone',
  'snow',
  'Spare_part_marker',
  'speaker',
  'square_root',
  'star',
  'storage',
  'substitute_on_frame',
  'substitute_on_new_frame',
  'suggest',
  'suggestion',
  'suggestion_sidenav',
  'sun',
  'suspended',
  'tab',
  'tag',
  'team',
  'team_leader',
  'team_planner',
  'template',
  'Template_report',
  'text',
  'threshold_calibration',
  'thumb',
  'ticket',
  'Ticket_marker',
  'ticket_sidenav',
  'time',
  'time_enrichment',
  'Time_lag',
  'time_setting',
  'timeline',
  'timer',
  'timeshift',
  'tips_updates',
  'topic',
  'touch',
  'trash',
  'tree',
  'tree_filter_selected',
  'trend_chart1',
  'trend_chart2',
  'trend_time_data_chart',
  'turbine',
  'un_pin',
  'undo',
  'unlock',
  'unlock2',
  'unpublished',
  'update_time',
  'upload',
  'us',
  'user',
  'user_placeholder',
  'user_preferences',
  'users',
  'visibility',
  'visibility_off',
  'wallet',
  'wallet2',
  'wallet3',
  'wallet_copy',
  'Warning_Diary',
  'watch',
  'waterfall',
  'wind',
  'wind_park',
  'wo_cart',
  'workspace',
  'world',
  'zero_count',
  'ko',
  'fr'
];

export const APP_ILLUSTRATIONS = [
  'acquisition_filters',
  'add_column_illustration',
  'add_dataset_from_exist',
  'add_dataset_from_file',
  'add_dataset_from_meter',
  'Alarms_settings',
  'alarms_not_found',
  'alternate_row_table',
  'area_chart',
  'autoML',
  'bar_chart',
  'binarizer_illustration',
  'bubble_chart',
  'card_carousel_loading',
  'clock',
  'column_chart',
  'contatore',
  'data_cleaning',
  'data_visualization_empty_state',
  'Dataset',
  'default_ai_model',
  'default_ai_model_in_production',
  'default_ai_project',
  'default_asset_ai',
  'default_asset_am',
  'default_asset_em',
  'default_asset_home',
  'default_asset_iiot',
  'default_asset_machinery',
  'default_dataset',
  'default_document',
  'default_edge_module',
  'default_energy_project',
  'default_enpi',
  'default_entry',
  'default_exit',
  'default_group_report',
  'default_maintenance_plan',
  'default_machinery_product',
  'default_measure',
  'default_meter_iiot',
  'default_meter_pod_pdr',
  'default_report',
  'default_rda',
  'default_site_ai',
  'default_site_am',
  'default_site_em',
  'default_site_home',
  'default_site_iiot',
  'default_site_machinery',
  'default_spare_part',
  'default_ticket',
  'default_transfer',
  'default_WO',
  'Delivery_sidenav_Delivery_sidenav_black',
  'dimensionality_reduction_illustration',
  'discretization_illustration',
  'donut_chart',
  'empty_movements',
  'empty_purchase_request',
  'empty_state_changerequest_license',
  'empty_state_modules',
  'encoding_illustration',
  'energy_vector',
  'enpi_no_exist',
  'error_buildingblock',
  'error_buildingblock_AI',
  'error_upload_file',
  'EnPI_target',
  'features_selection_illustration',
  'Feedback',
  'fixed_frequency_resampling_illustration',
  'frame',
  'frame_sidenav',
  'gauges',
  'generic_group',
  'group_sidenav',
  'grouped_column_chart',
  'Heuristic_Algorithm',
  'high_frequency_import',
  'history_ai',
  'infomap_empty_state',
  'infomap_no_data',
  'kpi_indicator',
  'labelling_illustration',
  'label_extension_illustration',
  'LogoMIPU',
  'material_entrance',
  'material_exit',
  'model_sidenav',
  'modeling',
  'models_not_found',
  'movements',
  'no_access_dataxp',
  'no_alarms',
  'no_data_AI',
  'no_data_IoT',
  'no_data_am',
  'no_data_dataeXp',
  'no_data_energy_atlas',
  'no_data_energy_atlas_2',
  'no_data_experience',
  'no_dataset',
  'no_device',
  'no_elements',
  'no_infomaps',
  'no_measure',
  'no_meter',
  'no_messages',
  'no_model',
  'no_model_production',
  'no_model_repository',
  'no_odl',
  'no_reports',
  'no_results',
  'no_results_ai',
  'Non ci sono documenti generati',
  'Non_ci_sono_template',
  'No_anomalies',
  'No_results_iot',
  'odl_sidenav',
  'one_hot_encoding_illustration',
  'optima_system',
  'pareto',
  'pdr_sidenav',
  'pie_chart',
  'pod_sidenav',
  'polynomial_features_illustration',
  'Postprocessing',
  'preprocessing',
  'product_sidenav',
  'progress_bar',
  'project_sidenav',
  'purchase_request',
  'radar_chart',
  'report_sidenav',
  'Rolling_statistics_illustration',
  'sankey',
  'scatterplot',
  'Scene',
  'seu',
  'Simulazione',
  'simple_import',
  'smart_labelling_illustration',
  'something_doesnt_add_up',
  'spare_parts',
  'stacked_areas_chart',
  'stacked_column_chart',
  'sunburst',
  'table',
  'Task_sidenav',
  'time_enrichment_illustration',
  'Time_lag_illustration',
  'transfers',
  'treemap',
  'trend_chart',
  'upload_file',
  'Versions_history',
  'Warning_Diary',
  'zero_count_illustration'
];

export const toastrConfig = {
  positionClass: 'toast-bottom-left',
  newestOnTop: false,
  timeOut: 8000,
  toastClass: 'ngx-toastr is-toast',
  iconClasses: {
    error: 'is-toast is-toast-error',
    info: 'is-toast is-toast-info',
    success: 'is-toast is-toast-success',
    warning: 'is-toast is-toast-warning'
  }
};
